import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Presentation, Video, Users } from "lucide-react";
import ZKTecoPresentation from "./ZKTecoPresentation";
import VideoResources from "./VideoResources";
import CustomerPresentation from "./CustomerPresentation";

export default function PresentationResource({ onBack }) {
  const [view, setView] = useState(null); // null = hub, "presentation", "videos", "customer"

  if (view === "presentation") {
    return <ZKTecoPresentation onBack={() => setView(null)} />;
  }

  if (view === "videos") {
    return <VideoResources onBack={() => setView(null)} />;
  }

  if (view === "customer") {
    return <CustomerPresentation onBack={() => setView(null)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center gap-4 mb-6">
          <Button variant="ghost" size="sm" onClick={onBack} className="text-slate-600 hover:text-slate-900" data-testid="pres-resource-back-btn">
            <ArrowLeft className="h-4 w-4 mr-1" /> Back to Dashboard
          </Button>
        </div>

        <div className="text-center mb-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2" data-testid="pres-resource-title">
            Presentation Resource
          </h1>
          <p className="text-sm text-slate-500">Explore products and access shareable video content.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <button
            onClick={() => setView("presentation")}
            className="group bg-white rounded-2xl border border-slate-200 shadow-sm p-8 hover:shadow-lg hover:border-slate-300 transition-all text-left"
            data-testid="pres-resource-presentation-btn"
          >
            <div className="flex flex-col items-center gap-4 text-center">
              <div className="w-16 h-16 rounded-xl bg-blue-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                <Presentation className="h-8 w-8 text-blue-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-slate-900 mb-1">ZKTeco Presentation</h2>
                <p className="text-xs text-slate-500">Interactive product portfolio</p>
              </div>
            </div>
          </button>

          <button
            onClick={() => setView("videos")}
            className="group bg-white rounded-2xl border border-slate-200 shadow-sm p-8 hover:shadow-lg hover:border-slate-300 transition-all text-left"
            data-testid="pres-resource-videos-btn"
          >
            <div className="flex flex-col items-center gap-4 text-center">
              <div className="w-16 h-16 rounded-xl bg-green-50 flex items-center justify-center group-hover:bg-green-100 transition-colors">
                <Video className="h-8 w-8 text-green-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-slate-900 mb-1">Video Resources</h2>
                <p className="text-xs text-slate-500">Browse & share product videos</p>
              </div>
            </div>
          </button>

          <button
            onClick={() => setView("customer")}
            className="group bg-white rounded-2xl border border-slate-200 shadow-sm p-8 hover:shadow-lg hover:border-slate-300 transition-all text-left"
            data-testid="pres-resource-customer-btn"
          >
            <div className="flex flex-col items-center gap-4 text-center">
              <div className="w-16 h-16 rounded-xl bg-orange-50 flex items-center justify-center group-hover:bg-orange-100 transition-colors">
                <Users className="h-8 w-8 text-orange-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-slate-900 mb-1">Customer Presentation</h2>
                <p className="text-xs text-slate-500">Build tailored presentations</p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
